/* eslint-disable */
import deepmerge from 'deepmerge'

const baseName = 'app.kiesrecht.2019.05'
const defaultParameters = {
  level2: 1,
  chapter1: 'undefined',
  chapter2: 'undefined',
  chapter3: 'special',
  customVars: {
    site: {
      1: '[site]', // `platform`
      2: '[nos]', // `broadcaster`
      3: '[nosop3]', // `programma`
      4: '[portal]', // `level2 type`
      6: '[article]', // `eventtype`
      7: '[general]', // `mediatype`
      9: '[site]', // `omroep 2 - nos platform`
      10: '[special]' // `omroep 3 - systemtag`
    }
  }
}

export function trekClick (click) {
  const trackingData = {
    name: `${baseName}.${click}.click`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('track', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekInteractive (interactive) {
  const trackingData = {
    name: `${baseName}.${interactive}.interactive`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('interactive', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekChoice (filename) {
  let char
  if (filename === 'fy') {
    char = 'female-young'
  }
  if (filename === 'fo') {
    char = 'female-old'
  }
  if (filename === 'mo') {
    char = 'male-old'
  }
  if (filename === 'my') {
    char = 'male-young'
  }

  const trackingData = {
    name: `${baseName}.${char}.choice`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('choice', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekSocial (platform) {
  const trackingData = {
    name: `${baseName}.${platform}.social`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('track', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekFeedback (platform) {
  const trackingData = {
    name: `${baseName}.${platform}.feedback`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('track', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekVideo (track) {
  const trackingData = {
    name: `${baseName}.${track}.video`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('track', trackingParameters)
  if (tag) {
    // track success
    tag.click.send(trackingParameters)
  }
}

export function trekChapter (chapter) {
  const trackingData = {
    name: `${baseName}.${chapter}`,
    type: 'action'
  }

  const trackingParameters = deepmerge(defaultParameters, trackingData)
  console.log('page', trackingParameters)
  if (tag) {
    // track success
    tag.page.send(trackingParameters)
  }
}
